import themes from "../../themes";

class T2TCanvas {
  constructor() {
    this.instaCanvas = this.createCanvas(1080, 1920);
    this.instaCtx = this.instaCanvas.getContext("2d");
    this.metaCanvas = this.createCanvas(1200, 630);
    this.metaCtx = this.metaCanvas.getContext("2d");
    this.name = "";
    this.pledge = null;
    this.uploadedImage = null;
  }
  createCanvas(width, height) {
    let canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    return canvas;
  }
  setName(name) {
    this.name = name;
  }
  setPledge(selection) {
    this.pledge = selection;
  }
  setUploadedImage(image) {
    let img = new Image();
    img.src = image;
    this.uploadedImage = img;
  }
  setBackground(bg) {
    if (this.uploadedImage === null) {
      if (bg === "red") {
        this.redMetaBG = themes[bg].facesBG;
        this.redInstaBG = themes[bg].facesIGS;
      } else if (bg === "teal") {
        this.tealMetaBG = themes[bg].facesBG;
        this.tealInstaBG = themes[bg].facesIGS;
      } else {
        this.navyMetaBG = themes[bg].facesBG;
        this.navyInstaBG = themes[bg].facesIGS;
      }
    } else {
      if (bg === "red") {
        this.redMetaBG = themes[bg].uploadBG;
        this.redInstaBG = themes[bg].uploadIGS;
      } else if (bg === "teal") {
        this.tealMetaBG = themes[bg].uploadBG;
        this.tealInstaBG = themes[bg].uploadIGS;
      } else {
        this.navyMetaBG = themes[bg].uploadBG;
        this.navyInstaBG = themes[bg].uploadIGS;
      }
    }
  }

  async drawInsta(bg) {
    this.setBackground(bg);
    let images = [this.pledge];
    if (bg === "red") {
      images.unshift(this.redInstaBG);
    } else if (bg === "teal") {
      images.unshift(this.tealInstaBG);
    } else {
      images.unshift(this.navyInstaBG);
    }
    let pos = [
      [0, 0],
      [30, 550],
    ];
    let size = [
      [1080, 1920],
      [992, 420],
    ];

    const loadImage = async (url) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => resolve(img);
        img.onerror = () => reject(new Error(`load ${url} fail`));
        img.src = url + "?skipcache";
      });
    };
    return Promise.all(images.map((image) => loadImage(image)))
      .then((images) => {
        images.forEach((image, i) => {
          this.instaCtx.drawImage(
            image,
            pos[i][0],
            pos[i][1],
            size[i][0],
            size[i][1]
          );
        });
        if (this.uploadedImage !== null) {
          this.instaCtx.drawImage(this.uploadedImage, 150, 1040, 780, 780);
        }
      })
      .then(() => {
        // add name
        let fontSize = 62;
        const text = {
          name: this.name.trim().charAt(0).toUpperCase() + this.name.slice(1),
        };
        this.instaCtx.font = `400 ${fontSize}pt "Avenir", "amatic-sc", 'sans-serif`;
        this.instaCtx.fillStyle = "#313131";
        this.instaCtx.fillText(text.name + ",", 120, 626);
      })
      .then(() => {
        let image = this.instaCanvas.toDataURL("image/png");
        return image;
      })
      .catch((err) => {
        console.error(err);
      });
  }

  async drawMeta(bg) {
    this.setBackground(bg);
    let images = [this.pledge];
    if (bg === "red") {
      images.unshift(this.redMetaBG);
    } else if (bg === "teal") {
      images.unshift(this.tealMetaBG);
    } else {
      images.unshift(this.navyMetaBG);
    }
    let pos = [
      [0, 0],
      [25, 260],
    ];
    let size = [
      [1200, 630],
      [708, 300],
    ];
    const loadImage = async (url) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = () => resolve(img);
        img.onerror = () => reject(new Error(`load ${url} fail`));
        img.src = url + "?nocache";
      });
    };
    return Promise.all(images.map((image) => loadImage(image)))
      .then((images) => {
        images.forEach((image, i) => {
          this.metaCtx.drawImage(
            image,
            pos[i][0],
            pos[i][1],
            size[i][0],
            size[i][1]
          );
        });
        if (this.uploadedImage !== null) {
          this.metaCtx.drawImage(this.uploadedImage, 735, 115, 400, 400);
        }
      })
      .then(() => {
        let fontSize = 44;
        // add name
        const text = {
          name: this.name.trim().charAt(0).toUpperCase() + this.name.slice(1),
        };
        this.metaCtx.font = `400 ${fontSize}pt "Avenir", "amatic-sc", 'sans-serif`;
        this.metaCtx.fillStyle = "#313131";
        this.metaCtx.fillText(text.name + ",", 85, 315);
      })
      .then(async () => {
        let image = this.metaCanvas.toDataURL("image/png");
        return image;
      })
      .catch((err) => {
        console.error(err);
      });
  }
}

export default T2TCanvas;
